module.exports = __webpack_public_path__ + "static/image/history/pc/201812@3x.ver2_0_2.jpg?5af44a4c";